import type { Api } from '@subaio/utils'
import { SystemStatusWidget } from '@subaio/webapp'

import { Logo } from 'components/Logo'

import { Container } from './Container'
import { Content } from './Content'
import { Copyright } from './Copyright'
import { LogoContainer } from './LogoContainer'

type Props = {
	statuspageApi: Api
}

export const Footer = ({ statuspageApi }: Props) => (
	<>
		<Container>
			<Content>
				<div>
					<Copyright>
						<LogoContainer>
							<a href='https://subaio.com'>
								<Logo />
							</a>
							<SystemStatusWidget api={statuspageApi} style={{ marginBottom: '12px' }} />
						</LogoContainer>
						<p>Copyright © {new Date().getFullYear()} Subaio ApS All rights reserved.</p>
					</Copyright>
				</div>
				<nav>
					<ul>
						<li>
							<a href='https://subaio.com/privacy-policy'>Privacy policy</a>
						</li>
						<li>
							<a href='https://subaio.com/cookie-policy'>Cookie policy</a>
						</li>
					</ul>
				</nav>
			</Content>
		</Container>
	</>
)
